export interface IPicker {
      id: string;
      locationId: string,
      location: {
        id: string,
        clientId: string,
        client: {
          id: string,
          name: string,
          phone: string,
          email: string,
          companyTaxId: string,
          status: string
        },
        automaticApproval: boolean,
        name: string,
        address: string,
        country: string,
        state: string,
        city: string,
        postalCode: string,
        latitude: string,
        longitude: string,
        status: string
      },
      userId: string,
      user: {
        id: string,
        firstName: string,
        lastName: string,
        email: string,
        phone: string,
        status: string
      },
      buildingName: string,
      floorNumber: string,
      identificationNumber: string
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface IPickerRes {
  data: IPicker;
}

export interface IPickersRes {
  data: IPicker[];
  count: number;
}

export enum Status {
  Active = "Active",
  Inactive = "Inactive",
  Delete = "Delete",
}

